import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { MonitorPolicy, MonitorSettings_Config } from 'DiscoveryEngine.TS/Monitors';
import { TftpSettings } from '../../../DiscoveryEngine.TS/Tftp/TftpSettings';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';


@Component({
	selector: 'config-tftp-settings',
	templateUrl: './configtftpsettings.component.html',
	styleUrls: ['./configtftpsettings.component.scss']
})
export class ConfigTftpSettingsComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	public serverAddress: UntypedFormControl;
	public serverPort: UntypedFormControl;
	public targetFolder: UntypedFormControl;
	public targetDir: UntypedFormControl;
	public fileNameFormat: UntypedFormControl;
	public fileWaitTimeout: UntypedFormControl;
	public requireAuth: UntypedFormControl;
	public userName: UntypedFormControl;
	public password: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public ngOnDestroy(): void {
		return;
	}

	public BuildForm(): void {
		let serverAddress = "";
		let serverPort = TftpSettings.DEFAULT_TFTP_PORT;
		let targetFolder = "";
		let targetDir = "";
		let fileNameFormat = "";
		let fileWaitTimeout = TftpSettings.DEFAULT_FILE_WAIT_TIMEOUT;
		let requireAuth = false;
		let userName = "";
		let password = "";

		if (!!this.editor && this.editor.HasPolicy) {
			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_Config = <MonitorSettings_Config>monPolicy.Settings;

			if (monSettings.HasTftpSettings) {
				let tftpSettings: TftpSettings = monSettings.TftpSettings;

				serverAddress = tftpSettings.ServerAddress;
				serverPort = tftpSettings.ServerPort;
				targetFolder = tftpSettings.TargetFolder;
				targetDir = tftpSettings.TargetDir;
				fileNameFormat = tftpSettings.FileNameFormat;
				fileWaitTimeout = tftpSettings.FileWaitTimeout;
				requireAuth = tftpSettings.RequireAuth;
				userName = tftpSettings.UserName;
				password = tftpSettings.Password;
			}
		}

		this.serverAddress = new UntypedFormControl(serverAddress/*, Validators.required*/);
		this.serverPort = new UntypedFormControl(serverPort, Validators.compose([this.minValue(0), this.maxValue(65535)]));
		this.targetFolder = new UntypedFormControl(targetFolder);
		this.targetDir = new UntypedFormControl(targetDir);
		this.fileNameFormat = new UntypedFormControl(fileNameFormat);
		this.fileWaitTimeout = new UntypedFormControl(fileWaitTimeout, Validators.compose([this.minValue(0), this.maxValue(3600)]));
		this.requireAuth = new UntypedFormControl(requireAuth);
		this.userName = new UntypedFormControl(userName, this.requiredIf(() => !!this.requireAuth, "userNameRequired"));
		this.password = new UntypedFormControl(password, this.requiredIf(() => !!this.requireAuth, "passwordRequired"));

		this.SettingsForm = this.fb.group({
			serverAddress: this.serverAddress,
			serverPort: this.serverPort,
			targetFolder: this.targetFolder,
			targetDir: this.targetDir,
			fileNameFormat: this.fileNameFormat,
			fileWaitTimeout: this.fileWaitTimeout,
			requireAuth: this.requireAuth,
			userName: this.userName,
			password: this.password,
		});
	}

	public applyTempChanges(): void {
		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_Config = <MonitorSettings_Config>monPolicy.Settings;

			let tftpSettings = new TftpSettings();
			monSettings.TftpSettings = tftpSettings;

			tftpSettings.ServerAddress = this.serverAddress.value;
			tftpSettings.ServerPort = this.serverPort.value;
			tftpSettings.TargetFolder = this.targetFolder.value;
			tftpSettings.TargetDir = this.targetDir.value;
			tftpSettings.FileNameFormat = this.fileNameFormat.value;
			tftpSettings.FileWaitTimeout = this.fileWaitTimeout.value;
			tftpSettings.RequireAuth = this.requireAuth.value;
			tftpSettings.UserName = this.userName.value;
			tftpSettings.Password = this.password.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["TFTP Settings"];
	}
}
